import { render, staticRenderFns } from "./CommonFormWithCashFlowEditor.vue?vue&type=template&id=0096921a&lang=pug&"
import script from "./CommonFormWithCashFlowEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithCashFlowEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithCashFlowEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports